module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page2 animated fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.items.intro3.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.items.intro3.text)
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-side"
  }, [_c('img', {
    attrs: {
      "src": "media/intros/chart_2.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39acf709"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page2.vue
// module id = 133
// module chunks = 0